import * as React from 'react'
import SanityBlock from 'components/common/SanityBlock'
import Img from 'components/common/Img'
import clsx from 'clsx'

export default function HeroSimple({
	title,
	_rawDescription,
	image,
	imageOnRight,
}) {
	return (
		<section className="cntr padding grid items-center gap-8 md:grid-cols-2">
			<Img
				className={clsx(imageOnRight && 'md:order-last')}
				{...image}
				objectFit="contain"
			/>

			<div className="richtext mx-auto max-w-[450px]">
				{title && <h2 className="h1">{title}</h2>}
				<SanityBlock body={_rawDescription} />
			</div>
		</section>
	)
}
